// Fixed AppBar (Navbar) clearance — Toolbar + vertical padding; keep in sync with Navbar.js
// Two-row desktop header: contact strip + toolbar (keep in sync with Navbar.js)
export const MAIN_TOP_PADDING = '132px';

// Extra space below the bar before hero copy (home pulls up to full-bleed behind transparent nav)
export const HOME_HERO_CONTENT_INSET = '2rem';
